<template>
    <div>
        <h1> {{ $t('MEMBERSHIP_SUCCESS_TITLE') }} </h1>
        <section v-dompurify-html="content"></section>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            content: ''
        }
    },
    mounted: function () {
        let membershipInfo = this.$route.query.info;
        let content = this.$t('MEMBERSHIP_SUCCESS_TEXT');
        content = content.replace('[MembershipInfo]', membershipInfo);
        this.content = content;
    }
}
</script>

<style lang="sccs" scoped>
    
</style>